import { createContext, useContext } from 'react';
import type { A11yState, Mode, ModeData } from '../../types';

export type A11yStateContextProps = {
  a11yState: A11yState;
  isA11yStateModified: boolean;
  modifiedSettingsCount: number;
  setA11yState(state: A11yState): void;
  setA11yMode(mode: Mode, settings: ModeData['settings']): void;
  resetA11yState(): void;
};

export const A11yStateContext = createContext<
  A11yStateContextProps | undefined
>(undefined);

export function useA11yState(): A11yStateContextProps {
  const context = useContext(A11yStateContext);

  if (!context) {
    throw new Error('useA11yState must be used within an A11yStateProvider');
  }

  return context;
}
